module.exports = __webpack_public_path__ + "static/media/Microbrew-Two-3D-Regular.abcf0c35.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Microbrew-Two-3D-Regular.woff
// module id = 1691
// module chunks = 49